import { useQuery } from 'react-query'
import { getSettingsAll } from 'services/cm-api/get-settings-all'

export function useGetSettingsAll(id: number | string) {
  return useQuery(['getSettingsAll'], () => getSettingsAll(id), {})
}
